<form [formGroup]="control" data-cy="evc-simulator" class="flex flex-col flex-grow">
  <div class="my-16 container m-auto">
    <ife-progress-bar
      *ngIf="(step$ | async) !== evSimulatorSteps.personalCalculation"
      [step$]="step$"
      [stepOrder]="evSimulatorStepsOrder"
      [barType]="progressBarType"
    >
    </ife-progress-bar>
  </div>

  <app-existing-client
    [@inOutAnimation]
    *ngIf="(step$ | async) === evSimulatorSteps.existingClient"
    formControlName="existingClient"
    (formReady)="goToStep(evSimulatorSteps.houseType)"
  >
  </app-existing-client>

  <app-house-type
    [@inOutAnimation]
    *ngIf="(step$ | async) === evSimulatorSteps.houseType"
    formControlName="houseInfo"
    (formReady)="goToStep(evSimulatorSteps.chargingStationPlacement)"
    (goBack)="goToStep(evSimulatorSteps.existingClient)"
  ></app-house-type>

  <app-charging-station-placement
    [@inOutAnimation]
    *ngIf="(step$ | async) === evSimulatorSteps.chargingStationPlacement"
    (formReady)="goToStep(evSimulatorSteps.chargingStationDistance)"
    (goBack)="goToStep(evSimulatorSteps.houseType)"
    formControlName="chargingStationPlacement"
  ></app-charging-station-placement>

  <app-charging-station-distance
    [@inOutAnimation]
    *ngIf="(step$ | async) === evSimulatorSteps.chargingStationDistance"
    (formReady)="goToStep(evSimulatorSteps.electricPhase)"
    (goBack)="goToStep(evSimulatorSteps.chargingStationPlacement)"
    formControlName="chargingStationDistance"
  ></app-charging-station-distance>

  <app-electric-phase
    [@inOutAnimation]
    *ngIf="(step$ | async) === evSimulatorSteps.electricPhase"
    (formReady)="goToStep(evSimulatorSteps.contactInfo)"
    (goBack)="goToStep(evSimulatorSteps.chargingStationDistance)"
    formControlName="electricPhase"
  ></app-electric-phase>

  <app-contact-info
    [@inOutAnimation]
    *ngIf="(step$ | async) === evSimulatorSteps.contactInfo"
    (goBack)="goToStep(evSimulatorSteps.electricPhase)"
    (formReady)="submit()"
    formControlName="contactInfo"
  ></app-contact-info>

  <app-personal-calculation
    *ngIf="(step$ | async) === evSimulatorSteps.personalCalculation"
    [simulation]="simulation"
  ></app-personal-calculation>
</form>
